import { Component, OnInit } from '@angular/core';
import { ModalController } from "@ionic/angular";

@Component({
  selector: 'app-no-internet',
  templateUrl: './no-internet.component.html',
  styleUrls: ['./no-internet.component.scss'],
})
export class NoInternetComponent implements OnInit {

  constructor(public modalController: ModalController) { }

  ngOnInit() {}

  doRetry(){
    if ((window && window.navigator && window.navigator.onLine) || (navigator && navigator["connection"] && navigator["connection"]["type"] != 'none')) {
      this.modalController.dismiss();
    }
  }
}
